import { motion } from "framer-motion";
import { Star, ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";
import { ASSETS, BRAND } from "@/data";
import LogoType from "@/components/LogoType";

const ease = [0.16, 1, 0.3, 1];

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden flex items-end" data-testid="hero-section">
      {/* Full-bleed portrait background */}
      <div className="absolute inset-0 -z-10">
        <img
          src={ASSETS.heroPoster}
          alt="Fairy Yasha — psychic reader, medium and energy healer"
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 18%" }}
          data-testid="hero-bg-image"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#140B09]/70 via-[#140B09]/20 to-[#140B09]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#140B09] via-transparent to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#140B09]/60 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1300px] w-full px-6 lg:px-10 pb-20 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease }}
          className="flex items-center gap-3 mb-5"
        >
          <span className="h-px w-10 bg-[#C9A24B]/70" />
          <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A24B] flex items-center gap-2">
            <Star className="w-3 h-3" fill="#C9A24B" strokeWidth={0} /> Welcome to
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.45, ease }}
        >
          <LogoType size="xl" />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.7, ease }}
          className="mt-7 text-xs sm:text-sm tracking-[0.28em] uppercase text-[#CDBE9F]"
        >
          {BRAND.tagline}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.9, ease }}
          className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-5"
        >
          <Link
            to="/pricing"
            data-testid="hero-cta-book"
            className="group relative overflow-hidden rounded-full bg-gradient-to-r from-[#9C2A52] to-[#C77E8A] px-8 py-4 text-xs tracking-[0.2em] uppercase text-[#EFE3CC] shadow-[0_0_36px_rgba(156,42,82,0.4)] transition-transform duration-300 hover:scale-[1.03]"
          >
            <span className="relative z-10">Book a Reading</span>
          </Link>
          <a
            href="#services"
            data-testid="hero-cta-explore"
            className="text-xs tracking-[0.2em] uppercase text-[#EFE3CC]/85 border-b border-transparent hover:border-[#C9A24B] hover:text-[#E9D3A0] transition-colors duration-300 pb-1"
          >
            Explore Services
          </a>
        </motion.div>

        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
          className="mt-8 inline-flex items-center gap-2 text-[11px] tracking-[0.15em] text-[#CDBE9F]"
        >
          <ArrowDown className="w-3.5 h-3.5 text-[#C9A24B] animate-bounce" strokeWidth={1.5} /> Live guidance within 24 hours
        </motion.span>
      </div>
    </section>
  );
}
